import { Navbar } from '@/components/layout/Navbar';
import { Card, CardContent } from '@/components/ui/card';
import { BookOpen, Compass, Camera, Edit3, MapPin } from 'lucide-react';

const Guide = () => {
  const steps = [
    {
      icon: Compass,
      title: '第一步:创建行程',
      desc: '进入"AI行程规划"页面,填写目的地、天数、预算等参数,点击"生成行程"按钮',
      tips: ['支持中国及全球主要旅游目的地', '可选择旅行风格:亲子游、情侣蜜月、美食探店等', '预算设置帮助AI推荐合适的景点和餐厅'],
    },
    {
      icon: Edit3,
      title: '第二步:优化调整',
      desc: 'AI生成初步行程后,您可以通过对话框继续优化,例如"增加美食推荐"、"调整第三天行程"',
      tips: ['支持多轮对话,随时调整行程细节', '可以添加特殊需求,如无障碍设施、素食餐厅等', '满意后点击"保存行程"即可收藏到个人中心'],
    },
    {
      icon: Camera,
      title: '第三步:旅途打卡',
      desc: '旅行过程中,使用"打卡相册"功能记录每个景点的照片和心情',
      tips: ['支持上传多张照片', '可添加地点标签和文字备注', '打卡记录可关联到对应行程'],
    },
    {
      icon: BookOpen,
      title: '第四步:撰写游记',
      desc: '旅行结束后,进入"旅行日记"撰写详细的图文游记,分享你的旅行故事',
      tips: ['支持富文本编辑', '可插入打卡照片', '可选择公开或私密,公开游记可被其他用户看到'],
    },
    {
      icon: MapPin,
      title: '第五步:回顾分享',
      desc: '在"个人中心"查看所有行程记录、旅行日记和打卡相册,随时回顾旅行足迹',
      tips: ['支持导出行程为图片', '可分享到社交媒体', '收藏的行程可随时查看和再次编辑'],
    },
  ];

  return (
    <div className="min-h-screen bg-[#FFFFFF]">
      <Navbar />
      <div className="max-w-5xl mx-auto px-4 md:px-6 pt-28 pb-20">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-[#1D1D1F] mb-4 tracking-tight">使用指南</h1>
          <p className="text-lg text-[#86868B] max-w-2xl mx-auto">
            5步轻松上手,开启你的智能旅行规划之旅
          </p>
        </div>

        <div className="space-y-8">
          {steps.map((step, idx) => (
            <Card key={idx} className="border-0 shadow-[0_4px_20px_rgba(0,0,0,0.04)] rounded-[20px] bg-[#FFFFFF] hover:shadow-[0_8px_30px_rgba(0,0,0,0.06)] transition-all">
              <CardContent className="p-8">
                <div className="flex items-start gap-6">
                  <div className="w-14 h-14 rounded-2xl bg-[#F5F5F7] flex items-center justify-center shrink-0">
                    <step.icon className="w-7 h-7 text-[#007AFF]" />
                  </div>
                  <div className="flex-1">
                    <h2 className="text-xl font-bold text-[#1D1D1F] mb-3">{step.title}</h2>
                    <p className="text-[#86868B] mb-4 leading-relaxed">{step.desc}</p>
                    <div className="bg-[#F5F5F7] rounded-xl p-4">
                      <p className="text-sm font-medium text-[#1D1D1F] mb-2">💡 小贴士:</p>
                      <ul className="space-y-1">
                        {step.tips.map((tip, tIdx) => (
                          <li key={tIdx} className="text-sm text-[#86868B] flex items-start gap-2">
                            <span className="text-[#007AFF] shrink-0">•</span><span>{tip}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <Card className="border-0 shadow-[0_4px_20px_rgba(0,0,0,0.04)] rounded-[20px] bg-[#F5F5F7] mt-12">
          <CardContent className="p-8 text-center">
            <h3 className="text-xl font-bold text-[#1D1D1F] mb-3">还有问题?</h3>
            <p className="text-[#86868B] mb-4">
              查看"常见问题"或联系客服获取帮助
            </p>
            <div className="flex justify-center gap-4">
              <a href="#/faq" className="text-[#007AFF] hover:underline">常见问题</a>
              <span className="text-[#E8E8ED]">|</span>
              <a href="#/contact" className="text-[#007AFF] hover:underline">联系客服</a>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Guide;
